// client/src/pages/Analytics.tsx

import React, { useState, useEffect } from "react";
import { getPerformanceData } from "../services/analyticsService";
import "../assets/styles/pages.css";

interface PerformanceData {
  averageScore: number;
  totalStudyHours: number;
  rank: number;
}

const Analytics: React.FC = () => {
  const [performance, setPerformance] = useState<PerformanceData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPerformance = async () => {
      setLoading(true);
      try {
        const data = await getPerformanceData();
        setPerformance(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPerformance();
  }, []);

  return (
    <div className="page analytics-page">
      <h2>Analytics</h2>
      {loading ? (
        <p>Loading performance data...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : performance ? (
        <div>
          <p>Average Score: {performance.averageScore}</p>
          <p>Total Study Hours: {performance.totalStudyHours}</p>
          <p>Rank: {performance.rank}</p>
        </div>
      ) : (
        <p>No analytics data available.</p>
      )}
    </div>
  );
};

export default Analytics;
